const initialState = {
    dataTableList: [],
    dataTableChildList: [],
    dataCategoriesSelectable: [],
    dataCategories: []
}

const categoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'FETCH_CATEGORY_TABLE':
            return {
                ...state,
                dataTableList: action.payload
            }

        case 'FETCH_CATEGORY_CHILD_TABLE':
            return {
                ...state,
                dataTableChildList: action.payload
            }

        case 'FETCH_CATEGORY_SELECTABLE':
            return {
                ...state,
                dataCategoriesSelectable: action.payload
            }
        case 'FETCH_CATEGORY_ALL':
            return {
                ...state,
                dataCategories: action.payload
            }
        default:
            return state
    }
}

export default categoryReducer
